import React, { useState } from 'react';
import { useDrag } from 'react-dnd';
import moment from 'moment';

const InboxData = ({ item, isShiftPressedMail, setIsShiftPressedMail, onItemDrag }) => {
    const [isHovered, setIsHovered] = useState(false);

    const [{ isDragging }, drag] = useDrag({
        type: isShiftPressedMail ? 'childTask' : 'task',
        item: isShiftPressedMail
            ? {
                  isShiftPressed: true,
                  item,
                  taskForCreate: true,
                  typeOf: 'Whatsapp',
              }
            : {
                  id: item?.id,
                  gmailMessage: item?.id,
                  isShiftPressed: false,
                  typeOf: 'Whatsapp',
                  item,
              },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
        end: (draggedItem, monitor) => {
            if (monitor.didDrop()) {
                onItemDrag(draggedItem);
            }
        },
    });

    const handleContextMenu = (event) => {
        event.preventDefault();
    };
    const colors = [
        'bg-green-500',
        'bg-blue-500',
        'bg-yellow-500',
        'bg-pink-500',
        'bg-purple-500',
        'bg-indigo-500',
        'bg-orange-500',
        'bg-emerald-500',
    ];

    const getColorFromName = (name) => {
        const safeName = name || '';
        const charCodeSum = safeName?.split('')?.reduce((sum, char) => sum + char?.charCodeAt(0), 0);
        return colors[charCodeSum % colors.length];
    };

    return (
        <div
            ref={drag}
            className={`max-w-sm  shadow border-l-[5px] hover:bg-[#FAFAFA] ${
                item.messageRead === 'unread' ? 'bg-gray-100' : 'bg-white'
            }`}
            style={{
                borderColor: item?.GmailUser?.colour || '#ccc',
                opacity: isDragging ? 0.5 : 1,
                padding: '0.5rem',
            }}
            onContextMenu={handleContextMenu}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="grid grid-cols-[8%_auto] items-start gap-1 p-2">
                {/* <div className="h-[26px]">
                    <div
                        onMouseEnter={() => setIsShiftPressedMail(true)}
                        onMouseLeave={() => setIsShiftPressedMail(false)}
                        data-no-popup
                        className="cursor-pointer"
                    >
                        <img src="assets/copy.svg" alt="copy" />
                    </div>
                </div> */}

                <div
                    className={`circle-user text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold ${getColorFromName(
                        item?.name,
                    )}`}
                >
                    {item?.name?.charAt(0)?.toUpperCase() || '?'}
                </div>

                {/* Content */}
                <div className="relative w-full">
                    {/* Top: Message + Time */}
                    <div className="grid grid-cols-[56%_auto] items-center">
                        <h2
                            className={`truncate h-[26px] text-[13.6px] ${
                                item.messageRead === 'unread' ? 'font-bold' : 'font-normal'
                            }`}
                        >
                            {item?.Chats?.[0]?.message}
                        </h2>
                        {/* {!isHovered && ( */}
                        <div className="flex flex-col items-end">
                            <span
                                className={`text-black text-[11.56px] ${
                                    item.messageRead === 'unread' ? 'font-bold' : 'font-normal'
                                }`}
                            >
                                {item?.createdAt ? moment(item.createdAt).format('MMM DD ') : ''}
                            </span>
                        </div>
                        {/* )} */}
                    </div>

                    <div className="grid grid-cols-[70%_auto] items-center text-[13.6px]">
                        <div className="flex flex-col space-y-1 " style={{ marginTop: '-3rem', marginLeft: '10px' }}>
                            <span className="text-sm text-gray-500">
                                {item?.contactNo?.split('@')[0]?.slice(-10) || 'Unknown'}
                            </span>
                            <h6
                                className={`text-black text-base  ${
                                    item.messageRead === 'unread' ? 'font-bold' : 'font-normal'
                                }`}
                                style={{ fontSize: 'small' }}
                            >
                                {item?.name ? item?.name : 'Unknown'}
                            </h6>
                        </div>
                        {/* <div className="flex gap-2 justify-end items-center">
                            <div
                                className={`circle-user text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold ${getColorFromName(
                                    item?.name,
                                )}`}
                            >
                                {item?.name?.charAt(0)?.toUpperCase() || '?'}
                            </div>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="currentColor"
                                className="bi bi-star"
                                viewBox="0 0 16 16"
                            >
                                <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                            </svg>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InboxData;
